export default function organizationaccountemails(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                organizationaccountemail: action.organizationaccountemail,
            }
        case 'ADD_CURRENT_ORGANIZATION':
            return {
                ...state,
                organizationaccountemail: action.organizationaccountemail,
                organization: action.organization,

            }
        default:
            return state;
    }
}
